'use client'

import { Holding } from '@hooks/useHoldings'
import { StakedListing } from './HoldingDetails.type'
import { useAsync } from 'react-async-hook'
import Badge from '@components/Badge'
import {
  auctionManagerKey,
  claimedMetadataKey,
  init as initAuctionManager,
} from '@dewicats/auction-manager-sdk'
import { useSolana } from '@dewicats/connect-button'
import { DEWICATS_COLLECTION } from '@utils/constants'
import { useMemo } from 'react'

const ClaimStakingRewardsButton = ({
  listing,
  holding,
}: {
  listing: StakedListing
  holding: Holding
}) => {
  const { anchorProvider } = useSolana()

  const { result: claimMetadata, loading: claimMetadataLoading } =
    useAsync(async () => {
      if (!anchorProvider) {
        return null
      }

      const auctionManagerProgram = await initAuctionManager(anchorProvider)
      const [auctionKey] = auctionManagerKey(DEWICATS_COLLECTION, 'dewicats')
      const [claimMetadataK] = claimedMetadataKey(holding.publicKey, auctionKey)

      try {
        const claimMetadata =
          await auctionManagerProgram.account.claimedMetadataV0.fetch(
            claimMetadataK,
          )
        return claimMetadata
      } catch (error) {
        return null
      }
    }, [anchorProvider])

  const listingClaimed = useMemo(() => {
    if (!claimMetadata) return false
    return claimMetadata.lastClaimAt.toNumber() > listing.createdAt.toNumber()
  }, [claimMetadata, listing.createdAt])

  return claimMetadataLoading ? (
    <div className="animate-spin h-4 w-4 border-2 border-gray-500 rounded-full border-t-transparent" />
  ) : (
    <Badge
      status={listingClaimed ? 'SUCCESS' : 'NEUTRAL'}
      label={listingClaimed ? 'Claimed' : 'Claimable'}
      size="small"
    />
  )
}

export default ClaimStakingRewardsButton
